export default __webpack_public_path__ + "static/media/revealed8.a575bc9f.png";